import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { api } from "../utils/hostname";
import url from "../url";

export type ResponseUserMascotInner = {
  id: string;
  name: string;
  link: string;
  status: "active" | "available";
  mascotId: string;
};

type ResponseUserMascots = {
  data: ResponseUserMascotInner[];
};

const requestUserMascots = () =>
  api(true, true).get<ResponseUserMascots>(url.config.api.loyalty.userMascots);

// Получить маскоты пользователя (активный и доступные)
export const useGetUserMascots = () => {
  return useQuery<AxiosResponse<ResponseUserMascots>>({
    queryKey: ["user mascots"],
    queryFn: requestUserMascots,
    staleTime: 5 * 60 * 1000,
  });
};
